import { render, staticRenderFns } from "./SubmitCode.vue?vue&type=template&id=78bc1258&scoped=true&"
import script from "./SubmitCode.vue?vue&type=script&lang=js&"
export * from "./SubmitCode.vue?vue&type=script&lang=js&"
import style0 from "./SubmitCode.vue?vue&type=style&index=0&id=78bc1258&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bc1258",
  null
  
)

export default component.exports